import { render, staticRenderFns } from "./UplodeImage.vue?vue&type=template&id=dc8d3cba&scoped=true"
import script from "./UplodeImage.vue?vue&type=script&lang=js"
export * from "./UplodeImage.vue?vue&type=script&lang=js"
import style0 from "./UplodeImage.vue?vue&type=style&index=0&id=dc8d3cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8d3cba",
  null
  
)

export default component.exports